module.exports = __webpack_public_path__ + "media/images/category_icons/gadgets-6036061f91983a58a44d34bf21d421e7.svg";